import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PortfolioHero from './components/PortfolioHero';
import PortfolioGrid from './components/PortfolioGrid';

export default function PortfolioPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <PortfolioHero />
        <PortfolioGrid />
      </main>
      <Footer />
    </div>
  );
}